@if (visible()) {
  <div class="oaa" role="dialog" aria-modal="true" aria-labelledby="oaaTitle">
    <div class="oaa__card">
      <h4 id="oaaTitle" class="oaa__title">Additional approval to vendor</h4>
      @if (loading()) {
        <p class="oaa__hint">Loading…</p>
      } @else if (ctx(); as c) {
        <p class="oaa__hint">
          The estimate is approved. Send the vendor <strong>{{ vendorName() }}</strong> the approval email so they can
          carry on. You can also close this and send it later from the Assign Vendor tab.
        </p>

        @if (error()) {
          <p class="oaa__error" role="alert">{{ error() }}</p>
        }

        <label class="oaa__label" for="oaaText">Approval text</label>
        <textarea
          id="oaaText"
          class="oaa__input oaa__input--area"
          rows="3"
          [ngModel]="approvalText()"
          (ngModelChange)="approvalText.set($event)"
        ></textarea>

        @if (c.estimates.length > 1) {
          <span class="oaa__label">Estimate</span>
          @for (e of c.estimates; track e.estimateKey) {
            <label class="oaa__row">
              <input
                type="radio"
                name="oaaEstimate"
                [checked]="selectedEstimate() === e.estimateKey"
                (change)="selectedEstimate.set(e.estimateKey)"
              />
              {{ e.label }}
            </label>
          }
        }

        <span class="oaa__label">Vendor contacts</span>
        @for (ct of c.contacts; track ct.contactKey) {
          <label class="oaa__row">
            <input
              type="checkbox"
              [checked]="selectedContacts().includes(ct.contactKey)"
              (change)="toggleContact(ct.contactKey, $any($event.target).checked)"
            />
            {{ ct.cname }} <span class="oaa__muted">({{ ct.email }})</span>
          </label>
        }

        <div class="oaa__foot">
          <button type="button" class="oaa__btn" (click)="close()" [disabled]="sending()">Not now</button>
          <button type="button" class="oaa__btn oaa__btn--primary" (click)="send()" [disabled]="!canSend()">
            {{ sending() ? 'Sending…' : 'Send approval email' }}
          </button>
        </div>
      }
    </div>
  </div>
}
